import { Button } from '@/ui';
import { ButtonProps } from 'antd';
import { ReactNode } from 'react';
import { StyledActions, StyledContent, StyledMessageModal } from './ConfirmationModalStyles';
import { useTranslation } from 'react-i18next';

export type TConfirmationModal = {
  isOpened: boolean;
  title?: ReactNode;
  content?: string | ReactNode;
  onConfirm?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  onCancel?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  afterClose?: () => void;
  okText?: ReactNode;
  cancelText?: ReactNode;
  okButtonProps?: Omit<ButtonProps, 'children'>;
  cancelButtonProps?: Omit<ButtonProps, 'children'>;
};

const ConfirmationModal = ({
  isOpened,
  content,
  onCancel,
  onConfirm,
  cancelButtonProps,
  okButtonProps,
  okText,
  cancelText,
  ...props
}: TConfirmationModal): JSX.Element => {
  const { t } = useTranslation(['common']);
  return (
    <StyledMessageModal
      {...props}
      open={isOpened}
      onCancel={onCancel}
      destroyOnClose
      okText
      footer={
        <StyledActions>
          <Button block shape="round" type="primary" onClick={onCancel} {...cancelButtonProps}>
            {cancelText || t('action_cancel')}
          </Button>
          <Button block shape="round" type="default" onClick={onConfirm} {...okButtonProps}>
            {okText || t('action_confirm')}
          </Button>
        </StyledActions>
      }
      styles={{
        mask: { background: 'rgba(0, 0, 0, 0.78)' },
      }}
    >
      {!!content && <StyledContent>{content}</StyledContent>}
    </StyledMessageModal>
  );
};

export default ConfirmationModal;
